// extracted by mini-css-extract-plugin
export default {"walkComponent":"Walk_walkComponent__EobAJ","canvas":"Walk_canvas__m0Xyx"};